// extracted by mini-css-extract-plugin
export default {"container":"styles_container__nTW76","title":"styles_title__VnRxg","text":"styles_text__8+-GG"};